module.exports = __webpack_public_path__ + "img/step1.8ea06e40.png";